<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item prop="sdate">
            <el-date-picker v-model="filters.sdate" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="excelSearch('filters')">文件导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>

        </el-form>
      </el-col>
      <el-alert title="提示：如不指定日期，默认查询昨天的数据" type="success"></el-alert>
      <!--列表-->
      <el-table :data="goods" :row-class-name="tableRowClassName" highlight-current-row v-loading="loading" style="width: 100%">

        <el-table-column prop="seldatetime" label="截止日期" min-width=" 60">
        </el-table-column>
        <el-table-column prop="name" label="业务经理" min-width=" 70">
        </el-table-column>
        <el-table-column prop="jobnumber" label="工号" min-width="40"> </el-table-column>
        <el-table-column prop="someprovince" label="省份" min-width="100"> </el-table-column>
        <el-table-column prop="taskmoney" label="月任务指标" min-width="60">
        </el-table-column>
        <el-table-column prop="goodsmoneytoday" label="当日发货" min-width="60"> </el-table-column>

        <el-table-column prop="goodsmoney" label="当月发货合计" min-width="50"> </el-table-column>
        <el-table-column prop="monthrate" label="月度完成率"> </el-table-column>

      </el-table>
      <!--工具条-->
      <!-- <el-col :span="24" class="toolbar">
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                    :total="total" style="float: right">
                </el-pagination>
            </el-col> -->
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../../api/frsendgoodsapi/goods";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      goods: [],
      filters: { sdate: "" },
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      console.log(row.jobnumber + " 检查列值");
      if (row.jobnumber === undefined || row.jobnumber === "") {
        return "warning-row";
      }
      return "";
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        console.log(index + " 第几列");
        console.log(column.property + " 列");

        if (index == 0) {
          sums[index] = "xx部门";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          if (index == 1) {
            return;
          }
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              // Math.round(num * 100) / 100   保留小数点后2位
              return Math.round((prev + curr) * 100) / 100;
            } else {
              return prev;
            }
          }, 0);
          //后面带单位 元
          // sums[index] += ' 元';
        } else {
          sums[index] = "";
        }
        //数据加工百分比保留小数点4位即 10000是4个0
        sums[6] = (Math.round((sums[5] / sums[3]) * 10000) / 10000) * 100 + "%";
      });

      return sums;
    },

    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    clickUpload() {
      this.$router.push("/sys/frsale/jdjieyu/upload");
    },
    // handleCurrentChange(val) {
    //     this.page = val;
    //     this.search();
    // },
    // handleSizeChange(val) {
    //     this.limit = val;
    //     this.search();
    // },
    handleSearch() {
      // this.total = 0;
      // this.page = 1;
      this.search();
    },

    search: function () {
      console.log(this.filters.sdate.toString() + "----选的日期1");
      var da = null;
      if (this.filters.sdate != "" && this.filters.sdate != null) {
        da = this.dateFormat(this.filters.sdate.toString().split(",")[0]);
        console.log(da + "----选的日期2");
        // +
        // "," +
        // this.dateFormat(this.value1.toString().split(",")[1]);
      }

      let that = this;
      let params = {
        // pageNum: that.page,
        // pageSize: that.limit,
        sendtime: da,
      };
      that.loading = true;

      API.getPageList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(
              "哇卡卡走到这没" + JSON.stringify(result.data.totalSize)
            );

            if (JSON.stringify(result.data.totalSize) == 0) {
              console.log("判断判断" + result.data.totalSize);
              that.goods = undefined;
            }
            if (JSON.stringify(result.data.totalSize) > 0) {
              that.total = result.data.totalSize;
              console.log(that.total + "--所有条数");
              that.goods = result.data.content;
              // console.log( result.data.content);
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => {});
    },

    excelSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.total = 0;
          // this.page = 1;
          // this.filters.type = 1;
          this.searchbyexcel();
        }
      });
    },

    searchbyexcel: function () {
      var da = null;
      if (this.filters.sdate != "" && this.filters.sdate != null) {
        da = this.dateFormat(this.filters.sdate.toString().split(",")[0]);
      }
      let params = {
        sendtime: da,
      };
      let paramsurl = "a=1"; //没啥作用仅用于后面固定有个&符号，否则接收参数报错的
      paramsurl += "&sdate=" + params.sendtime + "&rnd=" + Math.random();
      console.log(paramsurl + "---URL");
      location.href = "/api/sendgoods/exportExcel?" + paramsurl;
    },
  },

  mounted() {
    this.handleSearch();
  },
};
</script>

<style>
.el-table .warning-row {
  background: #f0f9eb;
  color: rgb(248, 141, 141);
}
</style>
